// src/lib/axios.js
import axios from 'axios'

const baseURL = process.env.VUE_APP_API_URL
const instance = axios.create({
  baseURL
})

// 请求拦截器
instance.interceptors.request.use(async (config) => {
    if (config.useToken) {
		try {
			config.headers['Authorization'] = `Bearer ${JSON.parse(localStorage.getItem('user')).accessToken}`
		} catch (e) {console.error(e)}
    }
    return config;
})
const decodeErrData = (data) => {
	console.info(data)
	if (typeof data === 'object' && data !== null) {
		const keys = Object.keys(data)
		return keys.filter(key => !/\d+/.test(key) && Array.isArray(data[key])).map(key => {
			return data[key].reduce((lhs, rhs) => {
				lhs.push(`${key} ${rhs}`)
				return lhs
			}, [])
		}).join('\n')
	}
}
// 响应拦截器
instance.interceptors.response.use(async (response) => {
	const {
		headers: {
			['content-type']: contentType
		},
		data
	} = response;
	if (/application\/json/.test(contentType) && data && !response.config.url?.startsWith('http') && !response.config?.NSR) {
		if (data.code === 0) {
			return data.data
		} else if (data.code === 99999) {
			// 特殊错误码处理
			// EventBus.$emit('error-401', '401-error')
			return Promise.reject('')
		} else {
			return Promise.reject(response.data);
		}
	}
	return response;
}, (err) => {
	// 对响应错误做点什么
	if (err.response?.data?.errorMsg) {
		const errorMsg = decodeErrData(err.response.data.data)
		return Promise.reject(errorMsg || err.response.data.errorMsg)
	}
	try {
		const errorObject = JSON.parse(JSON.stringify(err))
		const errMsg = errorObject.message
		return Promise.reject(errMsg)
	} catch (e) {
		console.error(e);
	}
	return Promise.reject(err)
});

export function get(url, config) {
  return instance.get(url, config)
}

export function post(url, data, config) {
  return instance.post(url, data, config)
}

export function put(url, data, config) {
  return instance.put(url, data, config)
}

export function del(url, config) {
  return instance.delete(url, config)
}


